import React from "react";
import ReactMarkdown from "react-markdown";

import { Typography } from "@mui/material";

export const textToMarkdown = (text = "") => {
    const styles = {
        link: {
            textDecoration: "underline",
            display: "inline !important",
            color: "#2e90fa",
            fontSize: "inherit",
        },
    };
    const components = {
        a: ({ node, href, ...props }) => {
            return (
                <Typography
                    {...props}
                    sx={styles.link}
                    variant="typography9"
                    component="a"
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                />
            );
        },
        p: React.Fragment,
    } as any;
    const allowedElements = ["a", "p"];
    return (
        <ReactMarkdown
            allowedElements={allowedElements}
            components={components}
        >
            {text}
        </ReactMarkdown>
    );
};
